export default __webpack_public_path__ + "static/media/raki_front.2cb9a3ed.jpg";